import * as Sentry from '@sentry/vue';
import {Vue} from 'vue-property-decorator';
import {CaptureConsole} from '@sentry/integrations';

class Monitoring {
	enabled = false; // Disabling Sentry till we can fix the surplus of errors decimating our quota

	init() {
		if(!this.enabled) {
			return;
		}
		Sentry.init({
			dsn: 'https://5a5a8853317e4c248fc188cf4b156c61@o489782.ingest.sentry.io/6137526',
			environment: process.env.VUE_APP_ENVIRONMENT,
			Vue: Vue,
			release: process.env.VUE_APP_SENTRY_RELEASE || '',
			integrations: [
				// new Sentry.Integrations.TryCatch({
				// 	eventTarget: false
				// }), // Attempt to fix hang, from here: https://github.com/getsentry/sentry-javascript/issues/2957#issuecomment-713505111
				new CaptureConsole({
					levels: ['error', 'warn'],
				}),
				// // new SentryRRWeb({
				// // 	maskAllInputs: false
				// // }), // Uses too much data
			],
			normalizeDepth: 21,
			// Set tracesSampleRate to 1.0 to capture 100%
			// of transactions for performance monitoring.
			// We recommend adjusting this value in production
			tracesSampleRate: 1.0,
		});
	}

	captureException(error: Error | any) {
		if(!this.enabled) {
			return;
		}
		try {
			Sentry.captureException(error);
		} catch(e) {
			console.log('Error capturing exception', e);
		}
	}

	setTag(key: string, value: string) {
		if(!this.enabled) {
			return;
		}
		try {
			Sentry.setTag(key, value);
		} catch(e) {
			console.log('Error setting tag', e);
		}
	}

	setUser(user: Sentry.User | null) {
		if(!this.enabled) {
			return;
		}
		try {
			Sentry.setUser(user);
		} catch(e) {
			console.log('Error setting user', e);
		}
	}
}



export const MonitoringService = new Monitoring();
